import { Component, ViewEncapsulation, ViewChild, TemplateRef, Input, ElementRef, Injectable, EventEmitter, Output } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppService } from '../app.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from '../message.service';
import { qmsService } from '../qms/qms.service';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { SuccessSnackbarComponent } from '../support/success-snackbar/success-snackbar.component';
import { NgModel } from '@angular/forms';
import { fakeAsync } from '@angular/core/testing';

@Component({
  selector: 'app-grid-reorder',
  templateUrl: './grid-reorder.component.html',
  styleUrls: ['./grid-reorder.component.scss']
})
export class GridReorderComponent {
  tempOrg: any;
  dateCustomClasses: DatepickerDateCustomClasses[];
  constructor(public dialog: MatDialog, private appService: AppService, public router: Router, private snackBar: MatSnackBar,
    public message: messageService, private elem: ElementRef, public qmsservice: qmsService
  ) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  }
  showremoveableField: boolean = false;
  ngOnInit() {
    this.isProcessing = true;
  };

  @Output() valueEmitter = new EventEmitter<string>();
  @ViewChild('reorderPopup', { static: true }) reorderPopup: TemplateRef<any>;
  visiblereorderPopup: MatDialogRef<TemplateRef<any>>;

  reorderPopupConfig = {
    width: '1400px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    position: { top: '10px' },
    maxWidth: '95vw',
    disableClose: true
  };

  @ViewChild('confirmPopup', { static: true }) confirmPopup: TemplateRef<any>;
  visibleconfirmPopup: MatDialogRef<TemplateRef<any>>;

  confirmPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    position: { top: '10px' },
    maxWidth: '95vw',
    disableClose: true
  };


  contentList: any = [];
  title: any = "Reorder Grid";
  datalist: any = {};
  isProcessing: boolean = false;
  rangevalidation(event: any, idx: any) {

    console.log('changed', this.contentList[idx].fieldSize, event);
    if (this.contentList[idx].fieldSize < 100) {
      this.contentList[idx].fieldSize = 100;
    } else if (this.contentList[idx].fieldSize > 400) {
      this.contentList[idx].fieldSize = 400;
    }

    // console.log(event.target.value);

    // console.log(event.target.attributes.value);
  }
  qualityAlert: boolean = false;
  reordercall(gridName: any, tableName: any, moduleName: any, groupId: any) {
    if (gridName == 'CR' || gridName == 'DV' || gridName == 'CAPA' || gridName == 'QI' || gridName == 'IN' || gridName == 'CC' || gridName == 'ACTIONS' || gridName == 'PARALLEL_WORKFLOW_ACTIONS' || gridName == 'CCP' || gridName == 'AU_FINDINGS' || gridName == 'AU_SCHEDULE' || gridName == 'AU_PLAN' || gridName == 'AU_CONDUCT' || gridName == 'AU_FOLLOWUPS') {
      this.showremoveableField = true;
    } else {
      this.showremoveableField = false;
    }
    this.isProcessing = true;
    this.qualityAlert = gridName == 'ACTIONS' || gridName == 'DOCUMENT' || gridName == 'EXTENSION' || gridName == 'EC' || gridName == 'EC_ACTION' || gridName == 'EC_DOCUMENT' || gridName == 'EC_PARTICIPANT' || gridName == 'DEPENDENCY';
    if (this.appService.getOrgVal()) {
      this.tempOrg = this.appService.getOrgVal() ? this.appService.getOrgVal().toString() : null;
      this.appService.setOrgVal('');
    } else {
      this.tempOrg = null;
    }
    this.datalist = {};
    let data = {
      orgId: this.tempOrg ? this.tempOrg : null,
      userId: this.message.getUserId(),
      tableName: tableName,
      moduleName: moduleName,
      gridName: gridName,
      groupId: groupId,
    };
    this.datalist = data;
    this.isProcessing = false;
    this.reloadCall();
    this.visiblereorderPopup = this.dialog.open(this.reorderPopup, this.reorderPopupConfig);
  }

  confirmPopup1() {
    this.visibleconfirmPopup = this.dialog.open(this.confirmPopup, this.confirmPopupConfig);
  }

  confirmmethod() {
    this.reorderContentFunction(false);
  }

  cancelconfirmmethod() {
    this.visibleconfirmPopup.close();
  }

  closeHtmlContent() {
    this.visiblereorderPopup.close();
  };

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.contentList, event.previousIndex, event.currentIndex);
    for (let i = 0; i < this.contentList.length; i++) {
      this.contentList[i].newSeq = i + 1;
    }
  };

  validationFlag: boolean = false;
  lessThenValue: boolean = false;
  greaterThenValue: boolean = false;
  reorderContentFunction(value: boolean) {
    this.validationFlag = false;
    for (let k = 0; k < this.contentList.length; k++) {

      const field = document.getElementById(k + 100 + '') as HTMLInputElement;
      if (field != null) {
        field.style.color = (this.contentList[k].fieldSize > 400 || this.contentList[k].fieldSize < 100) ? 'red' : '#005c8a';
        if (this.contentList[k].fieldSize > 400 || this.contentList[k].fieldSize < 100) {
          this.validationFlag = true;
          this.lessThenValue = true && this.contentList[k].fieldSize < 100;
          this.greaterThenValue = true && this.contentList[k].fieldSize > 400;
        }

      }
    }

    if (!this.validationFlag) {
      let data = {
        orgId: this.tempOrg ? this.tempOrg : null,
        tableOrViewName: this.datalist.tableName,
        gridName: this.datalist.gridName,
        groupId: this.datalist.groupId,
      };
      this.isProcessing = true;
      this.appService.removeOrgGridFields(data).subscribe((Response: any) => {
        if (Response.resultType == 'S' && value) {
          this.updateEachValue();
        } else {
          this.valueEmitter.emit();
          console.log("valueEmitter");
          this.isProcessing = false;
          this.showSnackBar(Response.result, Response.resultType);
          this.visibleconfirmPopup.close();
          this.visiblereorderPopup.close();

        }
      }, (error) => {
        this.isProcessing = false;
        throw error;
      });

      setTimeout(() => {
        this.isProcessing = false;
      }, 3000);

    } else {
      this.showSnackBar('One or more of the entered values is ' + (this.lessThenValue ? 'less than 100' : 'greater than 400'), 'E');
    }
  };

  cancelReorderFunction() {
    this.visiblereorderPopup.close();
  };

  reloadCall() {
    this.isProcessing = true;
    this.appService.getreorderGirdColumnList(this.datalist).subscribe((data: any) => {
      for (let i = 0; i < data.length; i++) {
        data[i].newSeq = i + 1;
        data[i].currentSeq = i + 1;
        data[i].radioValue = [{
          displayExp: "Yes",
          valueExp: "Y"
        }, {
          displayExp: "No",
          valueExp: "N"
        }];

        if (data[i].isFieldRemovable) {
          data[i].isFieldRemovable1 = data[i].isFieldRemovable == 'Y' ? true : data[i].isFieldRemovable == 'FAC-Y' ? false : data[i].isFieldRemovable == 'N' ? false : data[i].isFieldRemovable;
        }
      }
      this.isProcessing = false;
      this.contentList = data;
    }, (error: any) => {
      this.isProcessing = false;
    });
  }

  updateEachValue() {
    let l = 0;
    for (const element of this.contentList) {

      let data: any = {
        orgId: this.tempOrg ? this.tempOrg : null,
        groupId: this.datalist.groupId,
        gridName: this.datalist.gridName,
        tableOrViewName: this.datalist.tableName,
        columnName: element.columnName,
        fieldName: element.changedFieldName,
        fieldSeq: element.newSeq,
        addedInGrid: element.addedInGrid,
        fieldSize: element.fieldSize,
        isFieldRemovable: null,
        fieldNotes: element.fieldNotes,
      };

      if (element.isFieldRemovable == 'NA') {
        data.isFieldRemovable = null;
      } else {
        data.isFieldRemovable = element.isFieldRemovable1 ? 'Y' : null;
      }
      this.appService.updateOrgGridFields(data).subscribe((Response: any) => {
        console.log(Response.resultType == 'S' + " " + element.changedFieldName);
        l++;
        if (Response.resultType == 'S') {
          l == this.contentList.length - 1 && this.commitMethod();
        } else {
          this.isProcessing = false;
        }
      });
    }

  }
  commitMethod() {

    let data = {
      orgId: this.tempOrg ? this.tempOrg : null,
      tableOrViewName: this.datalist.tableName,
      gridName: this.datalist.gridName,
      groupId: this.datalist.groupId,
    };
    this.appService.commitOrgGridFields(data).subscribe((Response: any) => {
      this.isProcessing = false;
      if (Response.resultType == 'S') {
        this.visiblereorderPopup.close();
        this.valueEmitter.emit();
        this.showSnackBar(Response.result, Response.resultType);
      } else {
        this.showSnackBar(Response.result, Response.resultType);
      }
    });
  }
  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: !this.message.breadcrumbData.thirdLevel
          ? this.message.breadcrumbData.secondLevel
          : this.message.breadcrumbData.thirdLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();

    });
    if (this.datalist.gridName == 'ALL_DOCS') {
      this.valueEmitter.emit();
    }

  }

  validateNumberFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  checkLength(event: any) {
    const value = event.target.value;
    if (value.length >= 150) {
      this.showSnackBar('Max length reached (150 characters)', 'E')
    }
  }
}
